import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { removeFromLocalStorage } from "../utils/webStorage";
import { openSuccessPopup } from "../Redux/Actions/PopupActions";
import { useDispatch } from "react-redux";

// 4 hr = 14400 second
const InactivityTracker = ({ timeoutInSeconds = 14400 }) => {
  const [isActive, setIsActive] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();

  const onInactive = () => {
    const excludedPaths = [
      "/login",
      "/signup",
      "/guidelines",
      "/",
      "/highlights",
      "/pricing",
      "/contactus",
    ];
    if (!excludedPaths.includes(history?.location?.pathname)) {
      openSuccessPopup(dispatch, {
        successPopUp: {
          message:
            "There was no activity for a while so we closed the session.",
          open: true,
        },
      });
      removeFromLocalStorage("user");
      window.localStorage.clear();
      history.push("/login");
    }
  };

  useEffect(() => {
    let timeoutId;
    const handleActivity = () => {
      setIsActive(true);

      // Reset the timeout
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        setIsActive(false);
        onInactive();
      }, timeoutInSeconds * 1000);
    };

    // Set up initial timeout
    timeoutId = setTimeout(() => {
      setIsActive(false);
      onInactive();
    }, timeoutInSeconds * 1000);

    // Attach event listeners for activity
    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);

    // Clean up event listeners and timeout on component unmount
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
    };
  }, [timeoutInSeconds]);

  return <></>;
};

export default InactivityTracker;
